import { useEffect } from 'react'
import { getLCP, getFCP, getCLS, getFID, getTTFB } from 'web-vitals'
import { withRouter } from 'react-router-dom'

const PerformanceTools = props => {
  useEffect(() => {
    if (props.location.search === '?perf=1') {
      getLCP(console.log)
      getFCP(console.log)
      getCLS(console.log)
      getFID(console.log)
      getTTFB(console.log)
    }
  })

  return null
}

export default withRouter(PerformanceTools)
